export const getOptionsSelected = (options, selected)=>{
    if (!options?.length || !selected?.length) return [];
    const optionsSelected = [];
    for (const selectedValue of selected){
        optionsSelected.push(options.find((option)=>String(selectedValue) === String(option.value)) ?? options[0]);
    }
    return optionsSelected;
};
export const getOptionSelected = (options, value)=>options?.find((item)=>value ? String(item.value) === String(value) : !!item.selected) ?? options?.[0];
export const getDefaultOption = (options)=>{
    if (!options?.length) return null;
    return options.find((option)=>option.selected) ?? options[0];
};
export function groupByHighlight({ values , featuredOptionsText , otherOptionsText , emptyOptionText  }) {
    const highlights = {
        highlight: [],
        noHighlight: []
    };
    let returnValue = [];
    if (emptyOptionText) {
        const emptyOption = {
            label: emptyOptionText,
            value: undefined
        };
        returnValue.push(emptyOption);
    }
    if (!values) return returnValue;
    for (const value of values){
        if (value.highlight) {
            highlights.highlight.push(value);
        } else {
            highlights.noHighlight.push(value);
        }
    }
    if (highlights.highlight.length > 0 && highlights.noHighlight.length > 0) {
        returnValue = [
            ...returnValue,
            {
                label: featuredOptionsText,
                options: highlights.highlight
            },
            {
                label: otherOptionsText,
                options: highlights.noHighlight
            }
        ];
    } else if (highlights.highlight.length > 0) {
        returnValue = [
            ...returnValue,
            ...highlights.highlight
        ];
    } else if (highlights.noHighlight.length > 0) {
        returnValue = [
            ...returnValue,
            ...highlights.noHighlight
        ];
    }
    return returnValue;
}
export const getItemIndex = (item, items)=>items.findIndex((targetItem)=>targetItem.value === item.value);

//# sourceMappingURL=select.js.map